export default {
    message: {
        "system": {
            "fail": "fail",
            "server error.": "server error.",
            "duplicated request": "duplicated request",
            "invalid request parameter": "invalid request parameter",
            "missing access token": "missing access token",
            "invalid access token": "invalid access token",
            "Forbidden_AccessSystem": "Forbidden_AccessSystem",
            "you are forbidden to access the api": "you are forbidden to access the api",
        },
        "menu": {
            "home": "主页",
            "product": "商品",
            "card": "点卡",
            "directtopup": "直充",
            "myaccount": "我的"
        },
        "search": {
            "name": "Search",
            "result": "Search Result",
            "keywords": "Popular Search Keywords",
        },
        "product": {
            "name": "All Products",
            "all": "All",
            "card": "Card",
            "directtopup": "Direct Top Up",
            "filter": "Filter",
            "notfind":"We could not find anything, please try something else."
        },
        "list": {
            "nomore": "No More Result"
        },
        "detail": {
            "cardselected": "Card Selected",
            "selectedcard": "Selecte Card",
            "stockout": "Stock Out",
            "purchasequantity": "Purchase Quantity",
            "purchaselimit": "Purchase Limit",
            "paymentchannel": "Payment Channel",
            "processingfees": "Processing Fees",
            "paymentunavailable": "Sorry, This Payment Channel Is Temporarily Unavailable.",
            "emailaddress": "E-mail Address",
            "youremail": "Your E-mail address",
            "sendcard": "Please fill in your email address, and we will send the point card you purchased through this email address.",
            "description": "Description",
            "instruction": "Instruction",
            "orderinformation": "Order Information",
            "fillinformation": "Please fill in order information",
            "confirm": "Confirm",
            "inputemail": "Please input your email",
            "checkorder": "Please confirm the contents of your order",
        },
        "ucp": {
            "myorders": "My Orders",
            "notification": "Notification",
            "livechat": "Live Chat",
            "recentpurchases": "Recent purchases",
        },
        "order": {
            "waitsend": "Wait Send",
            "sending": "Sending",
            "refunded": "Refunded",
            "partialrefund": "Partial Refund",
            "closed": "Closed",
            "completed": "Completed",
            "paynow": "Pay Now",
            "orderdetails": "Order details",
            "originalpricetotal": "Original price total",
            "gstinclusive": "GST Inclusive",
            "paymentstatus": "Payment Status",
            "paymentchannel": "Payment Channel",
            "processingfees": "Processing Fees",
            "createdon": "Created on",
            "expiredafter": "Expired after",
            "paid": "Paid",
            "total": "Total",
            "retrievecode": "Retrieve Code",
            "expiredate": "Expire Date",
            "copy": "Click to copy the text content to the clipboard"
        }
    }
}
